<template>
    <div>
        <h1>Телефония</h1>
        <p>
            В разделе <strong>Телефония</strong> вы можете подключить к вашему проекту различные телефонии,
            в которых вы работаете в рамках вашего бизнеса, например, Мегафон.
        </p>
        <h1>Добавление телефонии</h1>
        <p>
            Для того чтобы добавить телефонию, вам необходимо нажать на кнопку <strong>Подключить</strong> на иконке интересующей вас телефонии.
        </p>
        <p>
            <img
                src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=557f226399710090ba0a665030abd940&article_id=5250"
                alt="Список телефоний"
                style="width: 100%"
            />
        </p>
        <p>После нажатия откроется окно подключения телефонии, которое осуществляется в 3 шага:</p>
        <ul>
            <li>
                1 шаг — <strong>Выбор источника</strong>. В нем уже будет выбрана та телефония, на которой
                вы нажали кнопку подключить.
            </li>
            <li>
                2 шаг — <strong>Авторизируйтесь</strong>. Авторизуйте свою телефонию в приложении,
                введя необходимые параметры.
            </li>
            <li>
                3 шаг — <strong>Настройки</strong>. Настройте сопоставление пользователей проекта Data Heroes c пользователями телефонии.
                Также здесь можно совершить тестовый звонок для проверки.
            </li>
        </ul>
        <img
            src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=043b448dbfa5d7e8375638bd0ed8d68d&article_id=5250"
            alt="Выбор источника"
            style="width: 100%"
        />
        <p>
            После выбора данных по все полям нажмите кнопку <strong>Сохранить</strong>.
        </p>
        <h1>Изменение настроек телефонии</h1>
        <p>
            Если вы хотите изменить настройки телефонии, то вам необходимо нажать на три точки напротив телефонии
            и затем нажать на кнопку <strong>Настройки</strong>.
            <img
                src="https://dataheroes.platrum.ru/wiki/api/article/file?file_id=110a118524b07bc155b3b7484739ace9&article_id=5250"
                alt="Настройки телефоний"
                style="width: 100%"
            />
        </p>
        <p>Далее вы перейдете на страницу настроек вашей телефонии.</p>
        <p>
            <strong><u>Важно!</u></strong> Если вы не можете добавить/удалить/изменить настройки телефонии,
            то значит у вас недостаточно прав для этих действий. Ознакомиться с ролями системы можно по
            <a href="https://clck.ru/TStCX" target="_blank" rel="noopener noreferrer">ссылке</a>.
        </p>
        <p>
            <strong><u>Важно!</u></strong> Если вы не увидели необходимой вам телефонии,
            то сообщите нам об этом на почту info@dataheroes.pro или напишите в форме на сайте.
            Мы постараемся как можно скорее его добавить.
        </p>
    </div>
</template>

<script>
//hintId  <telephony>
export default {
    name: 'TelephonyHint',
    computed: {},
    components: {},
    data: () => ({}),
    methods: {},
    mounted() {},
}
</script>



<style lang="sass" scoped>
@import '@/vars.sass'
p
    font-size: 14px
</style>

